import { Carousel_V1 } from '@vernost_dev/vms-react-components/dist/Carousel_V1'

export const VmsCarousel = ({
  id,
  children,
  responsive,
  deviceType,
  showDots,
  arrows,
  customLeftArrow,
  customRightArrow,
  infinite,
  customDot,
  autoPlay,
  autoPlaySpeed,
  draggable,
  swipeable,
  renderDotsOutside,
  containerClass,
  itemClass,
  dotClass,
  sliderClass,
  partialVisible,
  customTransition,
  additionalClassName,
  additionalStyle,
  onCarouselSlideChange,
  onCarouselbeforeSlideChange,
  spacing,
  rewind,
  slidesToSlide,
  customButtonGroup,
  shouldResetAutoplay,
  additionalTransfrom,
  centerMode,
  transitionDuration,
  keyBoardControl,
  minimumTouchDrag,
  renderArrowsWhenDisabled,
  removeArrowOnDeviceType,
  rewindWithAnimation,
  focusOnSelect,
  renderButtonGroupOutside,
  activeSelectedIndex,
}) => {
  return (
    <Carousel_V1
      id={id}
      // children={}
      responsive={responsive}
      deviceType={deviceType}
      showDots={showDots}
      arrows={arrows}
      customLeftArrow={customLeftArrow}
      customRightArrow={customRightArrow}
      infinite={infinite}
      customDot={customDot}
      autoPlay={autoPlay}
      autoPlaySpeed={autoPlaySpeed}
      draggable={draggable}
      swipeable={swipeable}
      renderDotsOutside={renderDotsOutside}
      containerClass={containerClass}
      itemClass={itemClass}
      dotClass={dotClass}
      sliderClass={sliderClass}
      partialVisible={partialVisible}
      customTransition={customTransition}
      additionalClassName={additionalClassName}
      additionalStyle={additionalStyle}
      onCarouselSlideChange={onCarouselSlideChange}
      onCarouselbeforeSlideChange={onCarouselbeforeSlideChange}
      spacing={spacing}
      rewind={rewind}
      slidesToSlide={slidesToSlide}
      customButtonGroup={customButtonGroup}
      shouldResetAutoplay={shouldResetAutoplay}
      additionalTransfrom={additionalTransfrom}
      centerMode={centerMode}
      transitionDuration={transitionDuration}
      keyBoardControl={keyBoardControl}
      minimumTouchDrag={minimumTouchDrag}
      renderArrowsWhenDisabled={renderArrowsWhenDisabled}
      removeArrowOnDeviceType={removeArrowOnDeviceType}
      rewindWithAnimation={rewindWithAnimation}
      focusOnSelect={focusOnSelect}
      renderButtonGroupOutside={renderButtonGroupOutside}
      activeSelectedIndex={activeSelectedIndex}
    >
      {children}
    </Carousel_V1>
  )
}
